import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useI18n } from "@/i18n";
import { Users, Shield, User } from "lucide-react";

export default function AdminUsers() {
  const { t, direction } = useI18n();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/users")
      .then((r) => setUsers(r.data))
      .catch((e) => toast.error(formatApiError(e.response?.data?.detail)))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="w-48 ob-loader h-1 rounded-full bg-zinc-900 mx-auto mt-20" />;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-white flex items-center gap-3"><Users className="text-[#00E5FF]" /> {t("adm.usersTitle")}</h1>
        <p className="text-zinc-500 text-sm mt-1">{t("adm.allUsers")} ({users.length})</p>
      </div>

      <div className="ob-card rounded-md overflow-hidden">
        <table dir={direction} className="w-full text-sm">
          <thead>
            <tr className="text-zinc-500 text-xs border-b border-zinc-900">
              <th className={direction === 'rtl' ? 'text-right' : 'text-left'}>{t("common.name")}</th>
              <th className={direction === 'rtl' ? 'text-right' : 'text-left'}>{t("auth.email")}</th>
              <th className="text-start px-4 py-3 font-medium">{t("adm.role")}</th>
              <th className="text-start px-4 py-3 font-medium">{t("adm.accounts")}</th>
              <th className="text-start px-4 py-3 font-medium">{t("common.date")}</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} className="border-b border-zinc-900/60 hover:bg-white/[0.02]" data-testid={`user-row-${u.email}`}>
                <td className="px-4 py-3 text-end text-white font-medium">{u.name}</td>
                <td className="px-4 py-3 text-zinc-400 text-xs" dir="ltr">{u.email}</td>
                <td className="px-4 py-3">
                  {u.role === "admin" ? (
                    <span className="inline-flex items-center gap-1 text-[10px] text-[#00E5FF] bg-[#00E5FF]/10 px-2 py-0.5 rounded-full"><Shield size={11} /> {t("app.admin")}</span>
                  ) : (
                    <span className="inline-flex items-center gap-1 text-[10px] text-zinc-400 bg-white/5 px-2 py-0.5 rounded-full"><User size={11} /> {t("app.client")}</span>
                  )}
                </td>
                <td className="px-4 py-3 font-num text-zinc-300" dir="ltr">{u.accounts_count}</td>
                <td className="px-4 py-3 text-zinc-500 text-xs" dir="ltr">{new Date(u.created_at).toLocaleDateString("en-GB")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
